import systemBg from "../../images/systemBg.jpg";
import logo from "../../images/Charter-Logo.png";
import logoCanvas from "../../images/CanvasLogo.png";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { toast } from "react-toastify";
import api from "../../api/axiosInstance";
const Login = (props) => {
  const navigate = useNavigate();

  const getUserPermissions = (roleId, token) => {
    var config = {
      method: "get",
      url: process.env.REACT_APP_API_URL + "Roles/GetRole/" + roleId,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${token}`,
      },
    };

    api(config).then(function (response) {
      if (response.data.statusCode === 200) {
        console.log(response.data.content)
        props.setUserPermissions(response.data.content);
      }
      props.setIsLogged(true);
      toast.success("Login Successful");
      navigate("/Dashboard");
    });
  };

  const LoginUser = (e) => {
    e.preventDefault();

    var _email = document.getElementById("txtEmail").value;
    var _password = document.getElementById("txtPassword").value;

    const data = { email: _email, password: _password.replace("///", "/\\//") };

    var config = {
      method: "post",
      url: process.env.REACT_APP_API_URL + "Users/LoginUser",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
      },
      data: data,
    };

    api(config)
      .then(function (response) {
        if (response.data.statusCode === 200) {
          // UpdateLogs();
          props.setUser(response.data.content.checkUser);
          localStorage.setItem(
            "uTsReD",
            response.data.content.checkUser.userId
          );
          localStorage.setItem(
            "RTsReD",
            response.data.content.checkUser.roleId
          );
          localStorage.setItem(
            "OTsReD",
            response.data.content.checkUser.operatorId
          );
          localStorage.setItem(
            "STsReD",
            response.data.content.checkUser.schoolId
          );
          localStorage.setItem(
            "name",
            response.data.content.checkUser.firstName + " " + response.data.content.checkUser.lastName
          );
          getUserPermissions(
            response.data.content.checkUser.roleId,
            response.data.content.token
          );
          localStorage.setItem("access_token", response.data.content.token);
        } else if (response.data.statusCode === 401) {
          toast.warning(
            "You are unthorized to access the protal, please check with administrator."
          );
        } else if (response.data.statusCode === 406) {
          toast.warning(
            "Your account is locked! Please contact administrator."
          );
        } else {
          toast.error("Wrong email or password!");
        }
      })
      .catch(function (error) {
        if (error.code === "ERR_NETWORK")
          toast.error("An error has occured, please check with support.");
        toast.error(error);
      });
  };
  useEffect(() => {
    if (
      localStorage.getItem("uTsReD") != null &&
      localStorage.getItem("access_token") != null
    ) {
      props.setIsLogged(true);
    }
  }, []);
  return (
    <>
      <div
        className="container-fluid h-100vh loginPage d-md-flex align-items-center justify-content-center"
      // style={{ backgroundImage: `url(${systemBg})` }}
      >
        <form className="login-box" onSubmit={LoginUser}>
          <div className="row">
            {/* <div className="col-6 col-md-6 text-left">
              <img src={logoCanvas} className="logo" />
            </div> */}
            <div className="col-12 col-md-12 text-center">
              <img src={logo} className="logo" alt="CTS HR System Logo" />
            </div>
          </div>
          <div className="row form-inputs">
            <div className="col-12 mb-3">
              <h3 className="text-center">Canvas Data Dashboard</h3>
            </div>
            <div className="col-12 mb-3">
              <input
                placeholder="Email"
                className="form-control"
                id="txtEmail"
              />
            </div>
            <div className="col-12 mb-2">
              <input
                placeholder="Password"
                className="form-control"
                id="txtPassword"
                type="password"
              />
            </div>
            <div className="col-12 mb-3 forget-link">
              <Link to={"/ForgetPassword"}>Forgot Password ?</Link>
            </div>
            <div className="col-12">
              <button
                className="btn btn-primary cts-btn-primary-2"
                type="submit"
              >
                Login
              </button>
            </div>
          </div>
          <p className="footer-login-box">
            Developed By: CTS - All Rights Reserved - {process.env.REACT_APP_BUILD_VERSION}
          </p>
        </form>
    </div >
    </>
  );
};

export default Login;
